/**
 * @fileoverview Presentational component that renders the output in the console.
 *
 * @author Benjamin Leitner (bleitner@yext.com)
 */
goog.module('yext.m4.confcode.adminconsole.ConsoleComponent');

class ConsoleComponent extends React.Component {
  constructor(props) {
    super(props);
    this._scrollToBottom = this._scrollToBottom.bind(this);

    this._state = [];

    /** @type {!HTMLElement} */
    this.outputEnd;

    /** @type {!Props} */
    this.props;
  }

  componentDidMount() {
    this._scrollToBottom();
  }

  componentDidUpdate() {
    this._scrollToBottom();
  }

  /**
   * @private
   * Scrolls to the bottom of the console.
   */
  _scrollToBottom() {
    this.outputEnd.scrollIntoView({behavior: 'smooth'});
    this._checkForVisible(0, this.outputEnd);
  }

  /**
   * @private
   */
  _checkForVisible(tryNumber, element) {
    const MAX_TRIES = 10;
    if (tryNumber > MAX_TRIES) {
      return;
    }
    if (this._isInViewport(element)) {
      this.props.onTextRender();
    } else {
      setTimeout(() => {
        this._checkForVisible(tryNumber + 1, element);
      }, 300);
    }
  }

  /**
   * Checks if element is in viewport
   *
   * Copied from
   * https://gomakethings.com/how-to-test-if-an-element-is-in-the-viewport-with-vanilla-javascript/
   *
   * @returns {boolean}
   * @private
   */
  _isInViewport(elem) {
    const bounding = elem.getBoundingClientRect();
    // not checking the bottom of the element, sometimes this results in the element being _just_
    // outside the viewport. because of some css issue, on larger screens.
    return (
      bounding.top >= 0
      && bounding.left >= 0
      && bounding.right <= (window.innerWidth || document.documentElement.clientWidth));
  }

  render() {
    return (
      <div className={this.props.active ? 'tab-pane active sl-tools-console' : 'tab-pane sl-tools-console'} id="tools-console"
        role="tabpanel">
        <div className="console flex-grow-1 js-console">
          {this.props.lines.map((/** @type {!Line} */ line, index) => (
            <p key={index}>
              {line.type === 'error'
              && <span className={line.type + ' sl-console-error'}>ERROR: </span>
              }

              {line.type === 'warning'
              && <span className={line.type + ' sl-console-warning'}>WARNING: </span>
              }

              {!!line.meta
              && <span className="meta">{line.meta}</span>
              }

              {line.text}
            </p>
          ))}
          {/* Placeholder div that acts as an anchor to scroll to */}
          <div ref={el => {
            this.outputEnd = el;
          }}></div>
        </div>
      </div>
    );
  }
}

/** @record */
class Line {
  constructor() {
    /** @type {!string} */
    this.type;

    /** @type {!string} */
    this.meta;

    /** @type {!string} */
    this.text;
  }
}

/** @record */
class Props {
  constructor() {
    /**
     * The output to display in the console.
     * @type {!Array<!Line>}
     */
    this.lines;

    /**
     * The function to call after the text has been rendered and scrolled
     *
     * @type {!Function}
     */
    this.onTextRender;

    /** @type {!boolean} */
    this.active;
  }
}

exports = ConsoleComponent;
